import { render, staticRenderFns } from "./RecordValueStep.vue?vue&type=template&id=5c9b31ec&scoped=true"
import script from "./RecordValueStep.vue?vue&type=script&lang=ts"
export * from "./RecordValueStep.vue?vue&type=script&lang=ts"
import style0 from "./RecordValueStep.vue?vue&type=style&index=0&id=5c9b31ec&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9b31ec",
  null
  
)

export default component.exports